// 封装axios
import axios from 'axios';
import * as consts from '@/config/const';
import router from '@/router'
import {
  localStorage
} from '@/common/util/storage';
import {
  Notification,
  Loading
} from 'element-ui';
/* eslint-disable */
const STATUS_CODE = {
  HTTP: {
    401: '身份未验证',
    403: '你请求的内容服务器不让看',
    404: '服务器找不到你要查看的内容',
    405: '请求中指定的方法被禁止',
    406: '无法使用请求的内容特性响应请求的页面',
    407: '请求者未授权使用代理',
    408: '服务器等候请求时发生超时',
    409: '服务器在完成请求时发生冲突服务器必须在响应中包含有关冲突的信息',
    410: '如果请求的资源已永久删除，服务器就会返回此响应',
    411: '服务器不接受不含有效内容长度标头字段的请求',
    412: '服务器未满足请求者在请求中设置的其中一个前提条件',
    413: '服务器无法处理请求，因为请求实体过大，超出服务器的处理能力',
    414: '请求的 URI（通常为网址）过长，服务器无法处理',
    400: '服务器不理解请求的语法',
    415: '请求的格式不受请求页面的支持',
    416: '如果页面无法提供请求的范围，则服务器会返回此状态代码',
    417: '服务器未满足”期望”请求标头字段的要求。',
    429: '请求过多',
    431: '请求头字段太大',
    500: '服务器内部错误，无法完成请求',
    501: '服务器不具备完成请求的功能例如，服务器无法识别请求方法时可能会返回此代码',
    502: '服务器作为网关或代理，从上游服务器收到无效响应',
    503: '服务器目前无法使用（由于超载或停机维护）通常这只是暂时状态',
    504: '服务器作为网关或代理，但是没有及时从上游服务器收到请求',
    505: '服务器不支持请求中所用的 HTTP 协议版本',
    511: '需要网络认证'
  }
}
const frontServer = axios.create({});
// request 拦截器
frontServer.interceptors.request.use(
  config => {
    // 判断token
    config.withCredentials = true
    let token = localStorage.get('token');
    if (token) {
      config.headers['token'] = localStorage.get('token');
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// 获取状态码
function getStatusText(code, type) {
  let text = '未知状态码';
  if (STATUS_CODE[type][code] !== undefined) {
    text = STATUS_CODE[type][code];
  }
  return text;
}
// response 拦截器
frontServer.interceptors.response.use(
  response => {
    // 返回后把promise内相关清空，重新允许请求
    // promiseArr[response.config.url.trim()] = null;
    if (response.data.result.code === 1 || response.data.result.code === 3) {
      return response.data;
    } else {
      return response.data;
    }
  },
  error => {
    let statusText = getStatusText(error.response.status, 'HTTP');
    let statusCode = error.response.status;
    let url = error.config.url;
    if (statusCode < 200 || statusCode > 299) {
      // 不是 200 就报错
      if (statusCode === 401) {
        router.replace({
          name: 'home'
        });
        localStorage.remove('token');
      }
    }
    return Promise.reject(error);
  }
);
frontServer.defaults.baseURL = consts.SERVER_BASE_URL;
frontServer.defaults.timeout = 30000;
// 设置请求头，请求数据格式为form-Data
// axios.defaults.headers = {
//   'Content-Type': 'application/x-www-form-urlencoded',
//   'X-Requested-With': 'XMLHttpRequest'
// };
// 设置请求头，请求数据格式为JSON
frontServer.defaults.headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest'
};

function callback(res, resolve, reject, loadingInstance, unload, info) {
  if (loadingInstance) {
    loadingInstance.close();
  }
  if (
    res.result.code === consts.LOGIN_INCORRECT ||
    res.result.code === consts.SUCCESS
  ) {
    if (res.result.message && !unload && info) {}
    resolve(res);
  } else if (res.data.status === consts.OVERTIME) {
    // Notification.warning({
    //   title: '超时',
    //   message: res.data.message
    // });
    console.log('超时');
  } else if (res.data.status === consts.DUPLICATE_LOGON) {
    // Notification.warning({
    //   title: '多端重复登录',
    //   message: '您的账号于另一台电脑登录！'
    // });
    console.log('您的账号于另一台电脑登录');
  } else if (res.data.status === consts.BUSINESS_ERROR) {
    // 业务异常
    Notification.warning({
      title: '业务错误!',
      message: res.data.message
    });
    resolve(err);
  } else if (res.data.status === consts.PARAMS_ERROR) {
    // 参数错误
    // Notification.warning({
    //   title: '参数错误!',
    //   message: res.data.message
    // });
    console.log('参数错误');
  } else if (res.data.status === consts.SYSTEM_ERROR) {
    // 系统异常
    // Notification.error({
    //   title: '系统错误',
    //   message: res.data.message
    // });
    console.log('系统错误');
  } else if (res.data.status === consts.NO_PERMISSIONS) {
    // 无权限
    // Notification.warning({
    //   title: '您没有操作权限',
    //   message: res.data.message
    // });
    console.log('您没有操作权限');
  }
}

function error(err, resolve, reject, loadingInstance) {
  if (loadingInstance) {
    loadingInstance.close();
  }
  resolve(err);
}
export default {
  // get请求
  get(url, param) {
    return new Promise((resolve, reject) => {
      frontServer({
          method: 'get',
          url,
          params: param || {}
        })
        .then(res => callback(res, resolve, reject))
        .catch(err => error(err, resolve, reject));
    });
  },
  // post请求
  post(url, param, unload = false, info = true) {
    let loadingInstance = new Object();
    if (unload) {
      loadingInstance = null;
    } else {
      loadingInstance = Loading.service({
        customClass: 'appLoading',
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    }
    return new Promise((resolve, reject) => {
      frontServer({
          method: 'post',
          url,
          data: param || {}
        })
        .then(res => callback(res, resolve, reject, loadingInstance, unload, info))
        .catch(err => error(err, resolve, reject, loadingInstance, unload, info));
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/frontApi/api.js